.addLicensesModal {
  max-width: 640px;
  margin: auto;
}

p.addLicensesText {
  margin-top: 16px;
  font-size: 16px;
}
